// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b2b60593","460":"f100bce1"}[chunkId] + ".chunk.js";
};